package com.qrkontaq.ui.sections.footer.components

import androidx.compose.runtime.Composable
import com.qrkontaq.ui.sections.footer.SocialIconStyle
import com.qrkontaq.ui.theme.AppColors
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.dom.A

@Composable
internal fun SocialIcon(icon: String, url: String, label: String) {
    val colorMode = ColorMode.current
    val colors = AppColors.getColors(colorMode)

    A(
        href = url,
        attrs = Modifier
            .textDecorationLine(TextDecorationLine.None)
            .toAttrs {
                attr("target", "_blank")
                attr("rel", "noopener noreferrer")
                attr("aria-label", label)
            }
    ) {
        Box(
            modifier = SocialIconStyle
                .toModifier()
                .backgroundColor(colors.surfaceVariant),
            contentAlignment = Alignment.Center
        ) {
            SpanText(
                icon,
                Modifier
                    .fontSize(1.2.cssRem)
                    .attrsModifier { attr("aria-hidden", "true") }
            )
        }
    }
}
